import { z } from 'zod';

export const formSchema = z.object({
  name: z.string({ required_error: 'Nome do usuário é obrigatório' }),
  phone_number: z.string({
    required_error: 'Telefone do usuário é obrigatório',
  }),
});
